import { Banner, TErrorResponse } from '@lucidhq/lucidium';
import { ReactNode } from 'react';

export interface ErrorScreenProps {
  error: TErrorResponse;
  errorComponent?: ReactNode;
}

export const ErrorScreen = ({ error, errorComponent }: ErrorScreenProps) =>
  (errorComponent && <>{errorComponent}</>) || (
    <Banner palette="danger">{error.message}</Banner>
  );
